import type { IconProps } from "types";

const Sage = ({ className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.2"
      viewBox="0 0 875 1518"
      width="875"
      height="1518"
      className={className ? className : ""}
    >
      <style>
        {`.s0 { fill: #00d639 }`}
      </style>
      <path
        id="Layer"
        className="s0"
        d="m430.9 0c-244.6 0-430.4 185-430.4 422.6 0 260.3 185.8 360.9 391.8 422.8 195 61.6 287.5 130 287.5 265 0 137.2-102.1 233.4-235.4 233.4-133.8 0-249.5-96.2-249.5-244.4 0-82.2 38.6-103.1 38.6-148.7 0-52.6-36.1-91.3-95.3-91.3-67.5 0-137.7 103-137.7 249.3 0 235.6 201.8 408.8 443.9 408.8 244.5 0 430.4-185 430.4-422.5 0-258.4-185.9-361-393.8-422.6-192.5-59.4-285.6-130.3-285.6-265.3 0-134.5 99.7-230.7 233-230.7 138.2 0 249.5 98.2 251.4 233.2 2.2 61.6 45.2 98.1 95.3 98.1 52.1 0 99.7-36.5 97.2-103-4.4-235.6-201.3-404.7-441.4-404.7z"
      />
    </svg>
  );
};

export default Sage;
